import React, { useState } from 'react';
import { CheckCircle2Icon, Loader2Icon } from 'lucide-react';
import { inquiryTypes } from '../data/profile';
type Status = 'idle' | 'submitting' | 'success' | 'error';
const FIELD = 'w-full border border-mist bg-white px-4 py-3 text-sm text-navy placeholder:text-slate-400 transition-colors duration-150 ease-out focus:border-gold focus:outline-none focus:ring-1 focus:ring-gold';
export function InquiryForm() {
  const [status, setStatus] = useState<Status>('idle');
  const [error, setError] = useState<string | null>(null);
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const name = String(data.get('name') ?? '').trim();
    const message = String(data.get('message') ?? '').trim();
    if (!name || !message) {
      setStatus('error');
      setError('Please provide your name and a brief message.');
      return;
    }
    setError(null);
    setStatus('submitting');
    window.setTimeout(() => setStatus('success'), 900);
  };
  if (status === 'success') {
    return <div role="status" className="flex flex-col items-start border border-mist bg-white p-8" data-id="element-122" data-mp="99854ozv9j02">
        <CheckCircle2Icon className="h-7 w-7 text-gold-deep" aria-hidden="true" data-id="element-123" data-mp="nynt5x80jac2" />
        <h3 className="mt-4 font-serif text-2xl text-navy" data-id="element-124" data-mp="j6mbfvs2sren">Inquiry received</h3>
        <p className="mt-3 text-sm leading-relaxed text-charcoal" data-id="element-125" data-mp="wy0v84tt4wmr">
          Thank you. Your inquiry has been routed to the office of Rear Admiral
          (Ret.) Slavonic. Board and advisory requests typically receive a response
          within two business days.
        </p>
        <button type="button" onClick={() => setStatus('idle')} className="mt-6 text-sm font-semibold text-navy underline underline-offset-4 hover:text-gold-deep" data-id="element-126" data-mp="16u49ua5uinql">
          Submit another inquiry
        </button>
      </div>;
  }
  return <form onSubmit={handleSubmit} noValidate className="border border-mist bg-white p-8" data-id="element-127" data-mp="33qla8zle4fsn">
      <div className="grid gap-5 sm:grid-cols-2" data-id="element-128" data-mp="17nykwx7mj7yg">
        <div className="flex flex-col gap-2" data-id="element-129" data-mp="1clqavlopkk00">
          <label htmlFor="name" className="text-sm font-semibold text-navy" data-id="element-130" data-mp="1cmjn326fs1pj">
            Full name
          </label>
          <input id="name" name="name" type="text" className={FIELD} placeholder="Jane A. Whitfield" data-id="element-131" data-mp="1ll52iogm30m3" />
        </div>
        <div className="flex flex-col gap-2" data-id="element-132" data-mp="1qkzpwi16h82e">
          <label htmlFor="organization" className="text-sm font-semibold text-navy" data-id="element-133" data-mp="1qk7yljem5whx">
            Organization
          </label>
          <input id="organization" name="organization" type="text" className={FIELD} placeholder="Company, agency or board" data-id="element-134" data-mp="20a9jy3fl10t5" />
        </div>
        <div className="flex flex-col gap-2 sm:col-span-2" data-id="element-135" data-mp="29b7smz0ytwi2">
          <label htmlFor="inquiryType" className="text-sm font-semibold text-navy" data-id="element-136" data-mp="29csl8j3pz5da">
            Inquiry type
          </label>
          <select id="inquiryType" name="inquiryType" className={FIELD} defaultValue={inquiryTypes[0]} data-id="element-137" data-mp="2odzh5zt07i2i">
            {inquiryTypes.map(type => <option key={type} value={type} data-id="element-138" data-mp="2je4q9w98ashg">
                {type}
              </option>)}
          </select>
        </div>
        <div className="flex flex-col gap-2 sm:col-span-2" data-id="element-139" data-mp="2ehmmaylq2y66">
          <label htmlFor="message" className="text-sm font-semibold text-navy" data-id="element-140" data-mp="2afj8427o5fh7">
            Message
          </label>
          <textarea id="message" name="message" rows={5} className={FIELD} placeholder="Scope of the engagement, timing and any relevant context." data-id="element-141" data-mp="373p82btnbjp5" />
        </div>
      </div>

      {status === 'error' && error && <p role="alert" className="mt-5 border-l-2 border-gold-deep bg-offwhite px-4 py-3 text-sm text-charcoal" data-id="element-142" data-mp="2tckglx0flxpw">
          {error}
        </p>}

      <button type="submit" disabled={status === 'submitting'} className="mt-7 inline-flex items-center justify-center gap-2 bg-navy px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-indigo disabled:cursor-not-allowed disabled:opacity-70" data-id="element-143" data-mp="3l4i4j23icouw">
        {status === 'submitting' && <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-144" data-mp="2wndb8563ofl1" />}
        {status === 'submitting' ? 'Sending inquiry' : 'Submit inquiry'}
      </button>
      <p className="mt-4 text-xs leading-relaxed text-slate-500" data-id="element-145" data-mp="3odrj9krfmxos">
        Submissions are reviewed by Blue-Water Strategies. Please do not include
        confidential or non-public information.
      </p>
    </form>;
}